
import styled from "styled-components";
import DropdownMenu from "./DropdownMenu";
import Logo from "./Logo.jsx";
import {Link} from "react-router-dom";
import { LocationFilter } from "../LocationFilter";
import React from "react";

const StyledHeader = styled.header`
    background-color: #000000;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem 1rem 1rem;
    top: 0;
    left: 0;
    z-index: 50;
`;

const Header = ({showLocationFilters = true, selectedCountry, setSelectedCountry, selectedCity, setSelectedCity }) => {
    const handleCountryChange = (newCountry) => {
        setSelectedCountry(newCountry);
        setSelectedCity(""); // reset city when the country changes
    };

    return (
        <StyledHeader>
            
            <Link to="/">
                <Logo/>
            </Link>
            {showLocationFilters && (
                <div>
                    <LocationFilter
                        selectedCountry={selectedCountry}
                        setSelectedCountry={handleCountryChange}
                        selectedCity={selectedCity}
                        setSelectedCity={setSelectedCity}
                        stackVertical={false}
                        compact={false}
                        className=""
                    />
                </div>
            )}


            <div className="fixed top-3 right-3 z-50 pointer-events-auto">
                <DropdownMenu/>
            </div>
        </StyledHeader>
    );
};

export default Header;